import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Paragraph, DrawerDivider } from 'components/patterns'

export const StyledInputsWrapper = styled.div`
  > div {
    margin-top: 10px;
  }
`

export const StyledParagraph = styled(Paragraph)`
  margin-top: 5px;
  display: flex;

  &:before {
    content: '*';
    color: ${themeColor('inputRequiredWarning')};
    font-size: 16px;
    top: 3px;
    position: relative;
    margin-right: 3px;
  }
`

export const StyledDrawerDivider = styled(DrawerDivider)`
  margin: 20px 0px;
`

export const StyledWarningMessage = styled.div`
  padding: 10px 0;
  display: flex;
  svg {
    width: 20px;
    height: 14px;
  }

  span {
    margin-left: 8px;
    font-size: 90%;
  }
`
